import styled from "styled-components";

export const LoadingContainer = styled.div`
    padding: 43px 0 49px;
`;
export const RowLoadingContainer = styled.div`
    display: flex;
    justify-content: space-around;
    padding-bottom: 30px;
`;
